import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';

import paths from 'config/paths';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const GuestSessionLinks = ({ className }) => (
  <>
    <Link className={className} to={paths.login} href={paths.login} rel="nofollow">
      <FormattedMessage id="shared.header_log_in" />
    </Link>
    <Link className={className} to={paths.register} href={paths.register} rel="nofollow">
      <FormattedMessage id="shared.header_sign_up" />
    </Link>
  </>
);

GuestSessionLinks.propTypes = propTypes;
GuestSessionLinks.defaultProps = defaultProps;

export default GuestSessionLinks;
